import { IconButton } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';

export type VyToastCloseButtonProps = {
  closeToast: (e: React.MouseEvent<HTMLElement>) => void;
};

export const VyToastCloseButton: React.FC<VyToastCloseButtonProps> = ({ closeToast }) => (
  <IconButton onClick={closeToast} sx={{ height: '32px', width: '32px' }}>
    <VyIcon icon="CloseBig" color="#0D1B27DE" />
  </IconButton>
);
